import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MenuItemService } from 'src/app/services/menu.item.service';
import { MessagesService } from 'src/app/services/messages.service';
import { OrderService } from 'src/app/services/order.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-menu-physical-store',
  templateUrl: './menu-physical-store.component.html',
  styleUrls: ['./menu-physical-store.component.scss']
})
export class MenuPhysicalStoreComponent implements OnInit {

  public user: string;
  public role: string;
  public mensajesNoLeidos: string;
  public activeUser: string;
  public forcedChangePassword: string;
  public navImage = CONSTANTES.navBarImage;
  public menuImage = CONSTANTES.menuImage;
  public menuItems: string[] = [];
  public numberRole: number;
  public articulosGuardados: string;
  public timeStamp= new Date().getTime();

  constructor(private mensajesService: MessagesService, private menuItemService: MenuItemService, private router: Router,
    private authService: AuthenticationService, private orderService: OrderService) { }

  pdfSrc="http://localhost/pcami/pdf/MANUAL_DE_USUARIO_"+localStorage.getItem("role")+".pdf"

  ngOnInit() {
    jQuery.getScript(CONSTANTES.menu);

    this.user = localStorage.getItem("nid");
    this.role = localStorage.getItem("role");
    this.numberRole = +localStorage.getItem("numberRole");
    this.orderService.currentArticles.subscribe(articles => this.articulosGuardados = articles);

    //this.mensajesService.currentMessages.subscribe(messages => this.mensajesNoLeidos = messages);

    this.checkUserActive();
    //this.checkForcedChangePassword();
    //this.mensajesNoLeidos = localStorage.getItem("mensajesNoLeidos");
    //this.mensajesNoLeidos === null ? "" : this.mensajesNoLeidos;

    // Obtenemos los menuItem a los que tiene permiso el usuario
    this.getMenuItems();

  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  checkUserActive() {
    this.activeUser = localStorage.getItem("active");
  }

  checkForcedChangePassword() {
    this.forcedChangePassword = localStorage.getItem("forcedChangePassword");
  }

  getMenuItems(){
    this.menuItemService.getMenuItemsByUser(this.user, this.role).subscribe(
      data => {
        if (getToken(data)) {
          data.menus.forEach(element => {
            this.menuItems.push(element.id.toString());
          });
        } else {
          this.logOut();
        }
      },
      error => {
        this.logOut();
      }
    )
  }

}
